import React from 'react';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { Button } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';

const HistoryBox = ({ data, onClose }) => {
  const handleDownloadPDF = () => {
    const doc = new jsPDF();
    doc.text('Device History Report', 14, 15);

    autoTable(doc, {
      head: [[
        'Date & Time', 'Blind Status', 'Latitude', 'Longitude',
        'Speed', 'Location', 'RdpSKM', 'Battery%', 'Network%'
      ]],
      body: data.map(entry => [
        entry.datetime,
        entry.status,
        entry.latitude,
        entry.longitude,
        entry.speed,
        entry.location,
        entry.rdpskm,
        entry.battery,
        entry.network
      ]),
      startY: 20,
      styles: { fontSize: 8 },
      headStyles: { fillColor: [0, 77, 64] }
    });

    doc.save('device-history.pdf');
  };

  return (
    <div style={{
      position: 'absolute',
      top: '40px',
      left: '50%',
      transform: 'translateX(-50%)',
      width: '95%',
      maxWidth: '1200px',
      height: '600px',
      backgroundColor: '#fff',
      borderRadius: '10px',
      boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
      zIndex: 1000,
      display: 'flex',
      flexDirection: 'column',
      padding: '20px'
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h3 style={{ margin: 0 }}>Device History</h3>
        <div>
          <Button
            onClick={handleDownloadPDF}
            clour="red"
            variant="outlined"
            startIcon={<DownloadIcon />}
           
            sx={{
              marginRight: '10px',
              borderColor: 'red',
              color: 'red',
              '&:hover': {
                borderColor: 'darkred',
                backgroundColor: 'rgba(255, 0, 0, 0.04)',
              },
            }}
          >
            Download PDF
          </Button>
          <button
            onClick={onClose}
            style={{ fontSize: '20px', background: 'none', border: 'none', cursor: 'pointer' }}
          >
            ❌
          </button>
        </div>
      </div>

      <div style={{ overflowY: 'auto', flex: 1, marginTop: '10px' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead style={{ position: 'sticky', top: 0, backgroundColor: '#1976d2', color: 'white', zIndex: 1 }}>
            <tr>
              <th>Date & Time</th>
              <th>Blind Status</th>
              <th>Latitude</th>
              <th>Longitude</th>
              <th>Speed</th>
              <th>Location</th>
              <th>RdpSKM</th>
              <th>Battery%</th>
              <th>Network%</th>
            </tr>
          </thead>
          <tbody>
            {data.map((entry, index) => (
              <tr key={index} style={{ borderBottom: '1px solid #ccc' }}>
                <td>{entry.datetime}</td>
                <td><strong>{entry.status}</strong></td>
                <td>{entry.latitude}</td>
                <td>{entry.longitude}</td>
                <td>{entry.speed}</td>
                <td>{entry.location}</td>
                <td>{entry.rdpskm}</td>
                <td>{entry.battery}</td>
                <td>{entry.network}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default HistoryBox;
